<template>
  <v-tooltip top :nudge-bottom="3" content-class="pendingClip-tooltip">
    <template v-slot:activator="{ on, attrs }">
      <div
        class="pendingClip"
        v-bind="attrs"
        :class="{ 'pendingClip--absolute': absolute }"
        v-on="on"
      >
        <img class="pendingClip-rotate" src="@/assets/img/ico_update.svg" />
        <slot />
      </div>
    </template>
    <h3>ビデオクリップを保存中</h3>
  </v-tooltip>
</template>

<script>
export default {
  name: 'PendingClip',
  props: {
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '100%',
    },
    absolute: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.pendingClip {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  width: 117.3px;
  height: 66px;
  &-tooltip {
    &.v-tooltip__content {
      width: 110px;
      height: 34px;
      padding: 1px 6px 2px;
      border-radius: 6px;
      box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.1);
      opacity: 0;
      background-color: #666;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.17;
      letter-spacing: normal;
      text-align: left;
      color: #fff;
      &:after,
      &:before {
        top: 100%;
        left: 50%;
        border: solid transparent;
        content: '';
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
      }

      &:after {
        border-color: rgba(33, 33, 33, 0);
        border-top-color: #666666;
        border-width: 5px;
        margin-left: -5px;
      }
      &:before {
        border-color: rgba(33, 33, 33, 0);
        border-top-color: #666666;
        border-width: 6px;
        margin-left: -6px;
      }
      &.menuable__content__active {
        opacity: 1 !important;
      }
    }
  }
  &-rotate {
    animation: rotation 4s infinite linear;
  }

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
  img {
    width: 32px;
    height: 32px;
  }
  &--absolute {
    position: absolute;
    top: 0;
  }
}
</style>
